<template>
    <div class="fullscreen-container">
        <iframe v-if="!showYinliao"
                src="/zhihuixinli.html"
                frameborder="0"
                class="fullscreen-iframe"></iframe>
        <iframe v-else
                src="/yinliao.html"
                frameborder="0"
                class="fullscreen-iframe"></iframe>
    </div>
</template>

<style scoped>
    .fullscreen-container {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    .fullscreen-iframe {
        width: 100%;
        height: 100%;
        display: block;
    }
</style>


<script>
    export default {
        data() {
            return {
                showYinliao: false
            }
        },

        methods: {

        },
        created() {
            const frame = localStorage.getItem('curframe');
            if (frame == "yinliao") {
                this.showYinliao = true;
            } else if (frame == "xinli") {
                this.showYinliao = false;
            } else {
                // 如果没有设置curframe或者值不是预期的，重定向到首页
                this.$router.push({ name: 'HomePage' });
            }
            console.log('curframe:', frame);
            console.log('showYinliao:', this.showYinliao);
        }
    }
</script>